export default __webpack_public_path__ + "static/accents-color-accessibility-light-5aa010965d211f7fd34d92b25a98c32a.png";